import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './Reset.css';

function Reset({ onLogout, username }) {
    const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [org_pword, setOrgPword] = useState("");
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (password!==passwordConfirm){
            setError('mismatched_pwords')
        }

        const formData = new FormData();
        formData.append('pword', password);
        formData.append('org_pword', org_pword);

        try {
            const response = await fetch(`${API_ENDPOINT}/index.php`, {
                method: 'POST',
                body: formData
            });

            if (response.ok) {
                const responseData = await response.json();

                if (responseData.success) {
                    onLogout();
                    
                } else if (responseData.error === 'E_RETRY_AFTER_X_MINUTES') {
                    setError(`Too many attempts. Please try again later.`);
                } else {
                    throw new Error('Incorrect Username or Password');
                }
            } else {
                throw new Error('Incorrect Username or Password');
            }
        } catch (e) {
            setError('Incorrect Username or Password');
            console.error(e);
        }
    };

    return (
        <div className="container">
            <div className="content">
                <form id="form" onSubmit={handleSubmit}>
                    <img src='archive/logos/logo-salesperf.png' alt="SalesPerf Logo" width='100%' />
                    <p>The admin has requested you reset your password, please enter your new password</p>
                    <input 
                        type='password'
                        id='pword'
                        name='org_pword'
                        placeholder='Old Password'
                        value={org_pword}
                        onChange={(e) => setOrgPword(e.target.value)}
                    />
                    <br />
                    <input
                        type="password"
                        id="pword"
                        name="pword"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <br />
                    <input
                        type="password"
                        id="pword_confirm"
                        name="pword_confirm"
                        placeholder="Re-enter Password"
                        value={passwordConfirm}
                        onChange={(e) => setPasswordConfirm(e.target.value)}
                    />
                    <br />
                    {error && <p className="error">{error}</p>}
                    <br />
                    <input type="submit" value="Submit" id="submit" />
                </form>
            </div>
        </div>
    );
}

export default Reset;